import {GetHome} from 'domain/usecases';
import {RemoteGetHome} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {getHomeEndpoint} from './get-home-endpoint';

export const makeGetHome = (useV3 = false): GetHome =>
	new RemoteGetHome(makeBFFApiUrl(getHomeEndpoint(useV3)), makeAuthorizeHttpClientDecorator());
